import classNames from 'classnames';
import styles from './ArticleInfo.module.scss';
import { UI_Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';
import { UI_LinkButton } from 'ui/components/1-atoms/Action/LinkButton/LinkButton';
import { UI_Button } from 'ui/components/1-atoms/Action/Button/Button';

export interface UI_ArticleInfoProps {
	className?: string;
	infoColumns?: { heading?: string; line?: string; line2?: string }[];
	linkButton?: { name: string; url: string };
	button?: {
		text: string;
		onClick: () => void;
		showButton: boolean;
	};
	layoutType?: 'Article' | 'Event';
	buttonStyle?: 'primary' | 'secondary';
}

export const UI_ArticleInfo: React.FC<UI_ArticleInfoProps> = ({
	className,
	infoColumns,
	linkButton,
	button,
	layoutType,
	buttonStyle = 'secondary',
}) => (
	<div className={classNames(styles.ArticleInfo, className)}>
		<div className={classNames(styles.ArticleInfo_content, { [styles.ArticleInfo_content__event]: layoutType === 'Event' })}>
			{infoColumns?.map((infoColumn, index) => (
				<div key={index} className={classNames(styles.ArticleInfo_element)}>
					{infoColumn.heading && (
						<UI_Paragraph bold className={classNames(styles.ArticleInfo_elementHeading)}>
							{infoColumn.heading}
						</UI_Paragraph>
					)}
					{infoColumn.line && <UI_Paragraph className={classNames(styles.ArticleInfo_elementText)}>{infoColumn.line}</UI_Paragraph>}
					{infoColumn.line2 && <UI_Paragraph className={classNames(styles.ArticleInfo_elementText)}>{infoColumn.line2}</UI_Paragraph>}
				</div>
			))}
			{linkButton && (
				<div className={styles.ArticleInfo_linkButton}>
					<UI_LinkButton style="secondary" href={linkButton.url}>
						{linkButton.name}
					</UI_LinkButton>
				</div>
			)}

			{button && (
				<div className={classNames([styles.ArticleInfo_actionButton, button.showButton && styles.ArticleInfo_actionButton__hidden])}>
					<UI_Button style={buttonStyle} title={button?.text} onClick={button?.onClick}>
						{button?.text}
					</UI_Button>
				</div>
			)}
		</div>
	</div>
);
